import { render } from "./DashboardInstitute.vue?vue&type=template&id=6de13662&scoped=true"
import script from "./DashboardInstitute.vue?vue&type=script&lang=js"
export * from "./DashboardInstitute.vue?vue&type=script&lang=js"

import "./DashboardInstitute.vue?vue&type=style&index=0&id=6de13662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de13662"]])

export default __exports__